import { collection, query, where, getDocs, addDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';
import bcrypt from 'bcryptjs';

/**
 * Hash un mot de passe avec bcrypt
 */
export async function hashPassword(password: string): Promise<string> {
  const saltRounds = 10;
  return await bcrypt.hash(password, saltRounds);
}

/**
 * Vérifie un mot de passe contre un hash
 */
export async function verifyPassword(password: string, hash: string): Promise<boolean> {
  return await bcrypt.compare(password, hash);
}

export async function initializeDefaultAdmin() {
  try {
    const email = 'admin@evdh.org';
    const password = '@123456';

    // Vérifier si l'admin existe dans Firestore
    const q = query(collection(db, 'users'), where('email', '==', email));
    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      // Hasher le mot de passe avant de le stocker
      const hashedPassword = await hashPassword(password);
      
      // Créer l'utilisateur dans Firestore
      await addDoc(collection(db, 'users'), {
        username: 'ADMIN',
        email: email,
        password: hashedPassword,
        phone: '0757000203',
        role: 'admin',
        createdAt: new Date()
      });
      console.log('Default admin user created in Firestore with hashed password');
    }
  } catch (error) {
    console.error('Error initializing admin:', error);
  }
}